import React, { useState } from 'react';
import P from 'prop-types';
import './styles.css';

export const Image = ({
  src = '',
  srcLocal = '',
  alt = 'image_not_found',
  className = '',
  size = 75,
  // eslint-disable-next-line no-unused-vars
  element = '',
}) => {
  const [imgInvalid, setImgInvalid] = useState(false);

  // const placeholderImage =
  //   'https://images.unsplash.com/photo-1511285605577-4d62fb50d2f7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=876&q=80';

  const onImageError = () => {
    //e.target.src = '';
    setImgInvalid(true);
    if (element !== '') {
      var el = document.getElementById(element);
      el.classList.remove('item_descricao');
    }
  };

  return (
    <>
      {/* style={{ width: size, height: size }} */}
      {srcLocal != '' && <img className={className} src={srcLocal} loading="eager" alt={alt} />}
      {src != '' && (
        <figure>
          <img
            className={className}
            style={{ width: size === '40vh' ? '100%' : size, height: size, display: imgInvalid ? 'none' : '' }}
            src={'https://www.garcomweb.com.br/office/' + src}
            loading="lazy"
            alt={alt}
            onError={onImageError}
          />
        </figure>
      )}
    </>
  );
};

Image.propTypes = {
  src: P.string,
  srcLocal: P.string,
  alt: P.string,
  className: P.string,
  //size: P.number | P.string ,
  size: P.any,
  element: P.string,
};
